module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAlUlEQVR42u3asQmAMBBA0RvBYdzEGV3HwoVOLC+NCAHBe8WvUuR4RSAkkZnRuQAAAAAAAAAAAAAAoDlAbHvOKI8onctaGtdn7ft6TgAAAAAAAAAAAAAAAAAAcDcMNqsngM8CAABAARgH/XsAAABwCAIAAMBlCAAAAAAAAAAAAAAAAACavwz5KQoAAAAAAAAAAAAAQKcudvOWOZ3OmPMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Aland.png
// module id = WQUe
// module chunks = 0 62 63